"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _styled = _interopRequireDefault(require("@emotion/styled"));

var _ChartStyles = require("../ChartStyles");

var _Download = _interopRequireDefault(require("./Download"));

var _Display = _interopRequireDefault(require("./Display"));

var _Interaction = _interopRequireDefault(require("./Interaction"));

var _propTypes2 = require("../../constants/propTypes");

require("react-vis/dist/style.css");

var _ChartLoader = _interopRequireDefault(require("../ChartLoader"));

var _templateObject;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var AbsoluteFull = _styled["default"].div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  position: absolute;\n  top: 0;\n  bottom: 0;\n  left: 0;\n  right: 0;\n"])));

var CumulativeChart = function CumulativeChart(_ref) {
  var contractCoordinates = _ref.contractCoordinates,
      hasBattery = _ref.hasBattery,
      isLoading = _ref.isLoading,
      peerCoordinates = _ref.peerCoordinates,
      peerV2Coordinates = _ref.peerV2Coordinates,
      productionCoordinates = _ref.productionCoordinates,
      timeZone = _ref.timeZone,
      viewEndISO = _ref.viewEndISO,
      viewStartISO = _ref.viewStartISO,
      internalUsage = _ref.internalUsage;
  return /*#__PURE__*/_react["default"].createElement(_ChartStyles.MainChartWrapper, null, /*#__PURE__*/_react["default"].createElement(_ChartLoader["default"], {
    isLoading: isLoading
  }), /*#__PURE__*/_react["default"].createElement(_ChartStyles.MainChartLeft, null, /*#__PURE__*/_react["default"].createElement(_Display["default"], {
    contractGenerationCoordinates: contractCoordinates,
    hasBattery: hasBattery,
    isLoading: isLoading,
    peerAdjCoordinates: peerCoordinates,
    peerV2Coordinates: peerV2Coordinates,
    siteCoordinates: productionCoordinates,
    timeZone: timeZone,
    viewEndISO: viewEndISO,
    viewStartISO: viewStartISO
  }), /*#__PURE__*/_react["default"].createElement(AbsoluteFull, null, /*#__PURE__*/_react["default"].createElement(_Interaction["default"], {
    contractGenerationCoordinates: contractCoordinates,
    hasBattery: hasBattery,
    peerAdjCoordinates: peerCoordinates,
    peerV2Coordinates: peerV2Coordinates,
    siteCoordinates: productionCoordinates,
    timeZone: timeZone,
    viewEndISO: viewEndISO,
    viewStartISO: viewStartISO
  }))), /*#__PURE__*/_react["default"].createElement(_ChartStyles.MainChartRight, null, /*#__PURE__*/_react["default"].createElement(_Download["default"], {
    contractGenerationCoordinates: contractCoordinates,
    hasBattery: hasBattery,
    peerAdjCoordinates: peerCoordinates,
    peerV2Coordinates: peerV2Coordinates,
    siteCoordinates: productionCoordinates,
    timeZone: timeZone,
    internalUsage: internalUsage
  })));
};

CumulativeChart.propTypes = {
  hasBattery: _propTypes["default"].bool,
  isLoading: _propTypes["default"].bool,
  contractCoordinates: _propTypes2.coordinatePropTypes,
  peerCoordinates: _propTypes2.coordinatePropTypes,
  peerV2Coordinates: _propTypes2.coordinatePropTypes,
  productionCoordinates: _propTypes2.coordinatePropTypes,
  internalUsage: _propTypes["default"].bool,
  timeZone: _propTypes["default"].string,
  viewEndISO: _propTypes["default"].string.isRequired,
  viewStartISO: _propTypes["default"].string.isRequired
};
CumulativeChart.defaultProps = {
  contractCoordinates: [],
  hasBattery: false,
  isLoading: false,
  peerCoordinates: [],
  peerV2Coordinates: [],
  productionCoordinates: [],
  timeZone: 'local',
  internalUsage: false
};
var _default = CumulativeChart;
exports["default"] = _default;